'use client'

import { useSyncExternalStore } from 'react'
import { PALETTES, THEME_STORAGE_KEY, type Palette, type ThemeName } from './theme'

const listeners = new Set<() => void>()
let theme: ThemeName | null = null

function readInitial(): ThemeName {
  // The boot script has already resolved the theme onto the root element.
  const fromDom = document.querySelector('.gd-root')?.getAttribute('data-theme')
  if (fromDom === 'paper' || fromDom === 'night') return fromDom
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY)
    if (stored === 'paper' || stored === 'night') return stored
  } catch {}
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'night' : 'paper'
}

function get(): ThemeName {
  if (!theme) theme = readInitial()
  return theme
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function setTheme(next: ThemeName) {
  theme = next
  try {
    localStorage.setItem(THEME_STORAGE_KEY, next)
  } catch {}
  for (const l of listeners) l()
}

export function useTheme(): ThemeName {
  return useSyncExternalStore(subscribe, get, () => 'paper')
}

/** Resolved colours for canvas / WebGL code that can't read CSS variables. */
export function useGdColors(): Palette {
  return PALETTES[useTheme()]
}
